/* eslint-disable quote-props */
define('config',[],function () {
    /**
    * Do not define shorter path for anything in `app` folder. It will break minification.
    * Use full relative path instead i.e. `require('widgets/country-selector/country-selector');`
    */
    requirejs.config({
        waitSeconds: 0,
        paths: {
            'api-access': '../js/bower_components/api-access/dist/api-access',
            'config': './config',
            'lib': '../js/lib',
            'es5-shim': '../js/bower_components/es5-shim/es5-shim',
            'es5-sham': '../js/bower_components/es5-shim/es5-sham',
            'console-polyfill': '../js/bower_components/console-polyfill/index',
            'babel-polyfill': '../js/bower_components/babel-polyfill/dist/polyfill',
            'fetch-polyfill': '../js/bower_components/fetch/fetch',
            'shared-g2m-logic': '../js/bower_components/shared-g2m-logic/dist/shared-g2m-logic',
            'react': '../js/bower_components/react/react',
            'react-dom': '../js/bower_components/react/react-dom',
            'knockout-bind-react': '../js/bower_components/knockout-bind-react/knockout-bind-react',
            'react-action-center': '../js/bower_components/react-action-center/dist/bundle',
            'react-banner-component': '../js/bower_components/react-banner-component/lib/amd/bundle',
            'react-product-purchase': '../js/bower_components/react-product-purchase/dist/bundle',
            'react-navbar': '../js/bower_components/react-navbar/dist/navbar',
            'react-settings-panes': '../js/bower_components/react-settings-panes/dist/settings-panes',
            'react-join-form': '../js/bower_components/react-join-form/dist/bundle',
            'text': '../js/bower_components/requirejs-text/text',
            'durandal': '../js/bower_components/durandal/js',
            'js-cookie': '../js/bower_components/js-cookie/src/js.cookie',
            'json3': '../js/bower_components/json3/lib/json3',
            'mixpanel-helper': '../js/lib/mixpanel/mixpanel-helper',
            'plugins': '../js/bower_components/durandal/js/plugins',
            'transitions': '../js/bower_components/durandal/js/transitions',
            'knockout': '../js/bower_components/knockout/dist/knockout',
            'knockout.validation': '../js/bower_components/knockout-validation/dist/knockout.validation.min',
            'knockout.punches': '../js/bower_components/knockout.punches/knockout.punches',
            'i18next': '../js/bower_components/i18next/i18next.amd',
            'jquery': '../js/bower_components/jquery/jquery',
            'jquery-ui': '../js/bower_components/jquery-ui/ui',
            'jquery-ui-helper': '../js/lib/binders/jquery-ui-helper',
            'knockout-jqueryui': '../js/bower_components/knockout-jqueryui/dist/amd',
            'file-upload': '../js/bower_components/jquery-file-upload/js/jquery.fileupload',
            'jquery.ui.widget': '../js/bower_components/jquery-file-upload/js/vendor/jquery.ui.widget',
            'file-upload-iframe': '../js/bower_components/jquery-file-upload/js/jquery.iframe-transport',
            'file-upload-process': '../js/bower_components/jquery-file-upload/js/jquery.fileupload-process',
            'file-upload-ui': '../js/bower_components/jquery-file-upload/js/jquery.fileupload-ui',
            'file-upload-validate': '../js/bower_components/jquery-file-upload/js/jquery.fileupload-validate',
            'file-upload-image': '../js/bower_components/jquery-file-upload/js/jquery.fileupload-image',
            'file-upload-load-image': '../js/bower_components/blueimp-load-image/js/load-image.min',
            'file-upload-load-image-meta': '../js/bower_components/blueimp-load-image/js/load-image-meta.min',
            'file-upload-canvas': '../js/bower_components/blueimp-canvas-to-blob/js/canvas-to-blob.min',
            'file-upload-tmpl': '../js/bower_components/blueimp-tmpl/js/tmpl.min',
            'file-upload-binding': '../js/lib/binders/jquery-file-upload',
            'bootstrap': '../js/bower_components/bootstrap/dist/js/bootstrap.min',
            'lodash': '../js/bower_components/lodash/lodash.min',
            'moment': '../js/bower_components/moment/min/moment-with-locales.min',
            'moment-timezone': '../js/bower_components/moment-timezone/moment-timezone',
            'moment-timezone-data': '../js/lib/time-zones/latest',
            'time': '../js/lib/time/time',
            'countries': '../js/lib/countries/countries',
            'time-zones': '../js/lib/time-zones/time-zones',
            'massage-countries': '../js/lib/massage-countries/massage-countries',
            'country-text': '../js/lib/countries/country-text',
            'popover-binder': '../js/lib/binders/popover',
            'mode-generator': '../js/lib/mode-generator/mode-generator',
            'preferred-country-generator': '../js/lib/preferred-country-generator/preferred-country-generator',
            'defaults-calculator': '../js/lib/defaults-calculator/defaults-calculator',
            'dialog-helper': '../js/lib/dialog-helper',
            'coorganizer-search': '../js/lib/binders/coorganizer-search',
            'web-urls': '../js/lib/web-urls/web-urls',
            'package-data': '../js/lib/package-data/package-data',
            'non-localized': '../../public/common/nonLocalized.json',
            'currencies': '../js/lib/currencies/currencies',
            'brightcove': 'https://sadmin.brightcove.com/js/BrightcoveExperiences',
            'cookie-handler': '../js/lib/cookie-handler/cookie-handler',
            'useragent-handler': '../js/lib/useragent-handler/useragent-handler',
            'tagmanager': '../js/lib/tagmanager/tagmanager',
            'tealium-utils': '../js/lib/tealium-utils/tealium-utils',
            'zero-clipboard': '../js/bower_components/zeroclipboard/dist/ZeroClipboard',
            'zero-clipboard-binding': '../js/lib/binders/zero-clipboard',
            'swfobject': '../js/bower_components/swfobject/swfobject/swfobject',
            'ie-support': '../js/lib/ie-support/ie',
            'meeting-id': '../js/lib/binders/meeting-id',
            'launch': 'empty:',
            'modernizr': '../js/bower_components/modernizr/modernizr',
            'bowser': '../js/bower_components/bowser/src/bowser',
            'filepicker': '../js/bower_components/filepicker.io/filepicker.min',
            'placeholders': '../js/support/placeholders/placeholders.jquery.min',
            'avatar-binder': '../js/lib/binders/avatar',
            'disable-click': '../js/lib/binders/disable-click',
            'numeric': '../js/lib/binders/numeric-input',
            'knockout-bind-html': '../js/bower_components/knockout-bind-html/knockout-bind-html',
            '@getgo/telemetry-client': '../js/bower_components/telemetry-client/dist',
            '@getgo/buffered-queue': '../js/bower_components/buffered-queue/dist/buffered-queue',
            'uuid': '../js/bower_components/uuid/src/uuid',
            'ua-parser': '../js/bower_components/ua-parser-js/src/ua-parser',
            'user-agent': '../js/bower_components/user-agent-info/src/user-agent',
            'steps-side-menu': '../js/bower_components/steps-side-menu/dist/SideMenu',
            'react-meeting-history': '../js/bower_components/react-meeting-history/dist/MeetingHistory',
            '@getgo/auth-client': '../js/bower_components/getgo-auth-client/lib/index.umd'
        },
        shim: {
            'bootstrap': {deps: ['jquery'], exports: 'jQuery'},
            'knockout.validation': {deps: ['knockout']},
            'knockout.punches': {deps: ['knockout']},
            'file-upload': {deps: ['jquery', 'jquery.ui.widget']},
            'file-upload-binding': {deps: ['file-upload']},
            'file-upload-iframe': {deps: ['file-upload']},
            'file-upload-process': {deps: ['file-upload']},
            'file-upload-validate': {deps: ['file-upload-process']},
            'brightcove': {exports: 'brightcove'},
            'swfobject': {exports: 'swfobject'},
            'modernizr': {exports: 'Modernizr'},
            'filepicker': {deps: [], exports: 'filepicker'}
        }
    });
});

